import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createVNode as _createVNode, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "rd-overflow-hidden error-notification-shade slide-down",
  role: "alert",
  "aria-live": "assertive",
  "aria-atomic": "true"
}
const _hoisted_2 = {
  id: "errorContainer",
  class: "shade-content rd-items-center rd-flex rd-justify-between"
}
const _hoisted_3 = { class: "rd-items-start rd-flex rd-justify-between rd-w-full" }
const _hoisted_4 = { class: "rd-flex rd-mr-5 rd-mt-2.5" }
const _hoisted_5 = {
  type: "button",
  class: "close-error-message"
}

import { useRenderStore } from '@/builder/stores/renderStore';
import { computed, ref, watch, onMounted } from 'vue';
import ErrorItem from './ErrorItem.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ErrorContainer',
  setup(__props) {

const renderStore = useRenderStore();

// refs
const showErrorContainer = ref(false);

// computed
const toasts = computed(() => renderStore.toasts);

// methods
const beforeEnter = (el) => {
    el.style.height = '0';
};

const enter = (el) => {
    el.style.height = el.scrollHeight + 'px';
};

const beforeLeave = (el) => {
    el.style.height = el.scrollHeight + 'px';
}

const leave = (el) => {
    el.style.height = '0';
}

const removeErrors = () => {
    renderStore.clearAllToasts();
};

// watchers
watch(toasts, (newToasts) => {
    showErrorContainer.value = newToasts.length > 0;
}, { deep: true });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, {
    appear: "",
    onBeforeEnter: beforeEnter,
    onEnter: enter,
    onBeforeLeave: beforeLeave,
    onLeave: leave
  }, {
    default: _withCtx(() => [
      (showErrorContainer.value)
        ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _cache[0] || (_cache[0] = _createElementVNode("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 24 24",
                    "aria-hidden": "true",
                    class: "alert-icon"
                  }, [
                    _createElementVNode("path", { d: "M12.8659 3.00017L22.3922 19.5002C22.6684 19.9785 22.5045 20.5901 22.0262 20.8662C21.8742 20.954 21.7017 21.0002 21.5262 21.0002H2.47363C1.92135 21.0002 1.47363 20.5525 1.47363 20.0002C1.47363 19.8246 1.51984 19.6522 1.60761 19.5002L11.1339 3.00017C11.41 2.52187 12.0216 2.358 12.4999 2.63414C12.6519 2.72191 12.7782 2.84815 12.8659 3.00017ZM10.9999 16.0002V18.0002H12.9999V16.0002H10.9999ZM10.9999 9.00017V14.0002H12.9999V9.00017H10.9999Z" })
                  ], -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(toasts.value, (toast) => {
                    return (_openBlock(), _createElementBlock("ul", {
                      key: toast.id
                    }, [
                      _createVNode(ErrorItem, {
                        id: toast.id,
                        text: toast.text,
                        duration: toast.duration,
                        class: _normalizeClass({ 'rd-mt-2.5': toasts.value.length > 1 })
                      }, null, 8, ["id", "text", "duration", "class"])
                    ]))
                  }), 128))
                ]),
                _createElementVNode("button", _hoisted_5, [
                  (_openBlock(), _createElementBlock("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 24 24",
                    "aria-hidden": "true",
                    onClick: removeErrors
                  }, _cache[1] || (_cache[1] = [
                    _createElementVNode("path", { d: "M11.9997 10.5865L16.9495 5.63672L18.3637 7.05093L13.4139 12.0007L18.3637 16.9504L16.9495 18.3646L11.9997 13.4149L7.04996 18.3646L5.63574 16.9504L10.5855 12.0007L5.63574 7.05093L7.04996 5.63672L11.9997 10.5865Z" }, null, -1)
                  ]))),
                  _cache[2] || (_cache[2] = _createElementVNode("span", { class: "sr-only" }, "Close error message", -1))
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})